<template>
  <div class="admin-datatable">
    <v-card class="mt-2 pb-1">
      <v-card-title>
        <v-toolbar flat dense dark color="primary">
          <v-toolbar-title>
            Najbliższe zawody
          </v-toolbar-title>
        </v-toolbar>
        <v-form class="flex">
          <v-layout row wrap justify-start>
            <v-flex xs12 sm6 md4 xl4 class="pa-1">
              <v-select
                v-model="context.priority"
                :items="[{text: 'A', value: 'A'}, {text: 'B', value: 'B'}, {text: 'C', value: 'C'}]"
                label="Priorytet"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md4 xl4 class="pa-1">
              <v-select
                v-model="context.raceType"
                :items="allRaceTypesStringsOptions"
                label="Rodzaj"
                clearable
              ></v-select>
            </v-flex>
              <v-flex xs12 sm6 md4 xl4 class="pa-1">
                <v-select
                  v-model="context.distance"
                  :items="allRaceDistanceStringsOptions"
                  label="Dystans (tylko uliczne i bieżnia)"
                  clearable
                ></v-select>
              </v-flex>
          </v-layout>
        </v-form>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="races"
        :pagination.sync="context"
        :rows-per-page-items="perPageOptions"
        :total-items="rowsTotal"
        :loading="loading"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>{{ props.item.name}}</td>
            <td>{{ props.item.race_type_name}}</td>
            <td v-if="['other', 'ultra'].indexOf(props.item.distance_string) > -1">{{ props.item.distance_km}} km</td>
            <td v-if="['other', 'ultra'].indexOf(props.item.distance_string) === -1">{{ props.item.distance_string_name}}</td>
            <td>{{ props.item.priority}}</td>
            <td>
              <span v-tooltip="formatDate(props.item.race_date)">{{ weeksToRace(props.item.race_date)}}</span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import {fetchRaces} from '../plan/api'
import {ListMixin} from '@/utils/ListMixin'
import { mapState, mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'races',
  mixins: [ListMixin],
  data () {
    return {
      context: {
        rowsPerPage: 3,
        sortBy: 'race_date',
        descending: false},
      perPageOptions: [3, 5, 10],
      type: null,
      loading: true,
      races: [],
      headers: [
        {
          value: 'name',
          text: 'nazwa',
          sortable: true
        },
        {
          value: 'race_type',
          text: 'rodzaj',
          sortable: true
        },
        {
          value: 'distance',
          text: 'dystans',
          sortable: true
        },
        {
          value: 'priority',
          text: 'priorytet',
          sortable: true
        },
        {
          value: 'race_date',
          text: 'tygodni do zawodów',
          sortable: true
        }
      ]
    }
  },
  computed: {
    ...mapState(['runner']),
    ...mapGetters(['allRaceDistanceStringsOptions', 'allRaceTypesStringsOptions'])
  },
  watch: {
    '$route': 'getRaces',
    context: {
      handler (a, b) {
        if (a.page === b.page && a.page !== 1) {
          this.context.page = 1
        } else {
          this.getRaces()
        }
      },
      deep: true
    }
  },
  methods: {
    weeksToRace (date) {
      return moment(date).diff(moment(), 'weeks')
    },
    formatDate (date) {
      return moment(date).format('LL')
    },
    getRaces () {
      this.loading = true
      let params = this.prepareParams()
      if (this.context.priority !== null) {
        params['priority'] = this.context.priority
      }
      if (this.context.raceType !== null) {
        params['race_type'] = this.context.raceType
      }
      if (this.context.raceType !== null) {
        params['race_type'] = this.context.raceType
      }
      if (this.context.distance) {
        params['distance_string'] = this.context.distance
      }
      params['race_date__gte'] = moment().format('YYYY-MM-DD')
      let promise = fetchRaces(this.runner, params)
      return promise.then(this.enhanceListData).then((data) => {
        this.loading = false
        this.races = data
        return data
      })
    },
    refresh: _.debounce(function () {
      this.getRaces()
    }, 400)
  }
}
</script>



// WEBPACK FOOTER //
// src/plan/PlanRaces.vue